const VOWELS = "aáeéiíoóöőuúüű";
// the letters whose Hungarian name starts with a vowel sound: á, é, ef, i, el, em, en, ó, er, es, u, iksz, ipszilon …
const VOWEL_NAMED = "AÁEÉIÍOÓÖŐUÚÜŰFLMNRSXY";

/** The article of a number as it is read out: "az 1.", "az 5.", "az 1000.", otherwise "a". */
function numberArticle(digits: string): "a" | "az" {
  const lead = digits[0];
  return digits === "1" || lead === "5" || (lead === "1" && digits.length % 3 === 1 && digits.length > 1) ? "az" : "a";
}

/** The Hungarian article before a value as it is read out. A number (a leading one, its thousands grouped by spaces):
 *  "az 1.", "az 5.", "az 1000.", "a 2024". A code read letter by letter — short capitals or letters without a vowel
 *  (MV, BW, DE, Lr34, Rht) — takes its first letter's name: "az MV", "a BW", "az Lr34". Any other word takes its
 *  first letter: "az Őszi", "a Bánkúti". Leading quotes and brackets are skipped. */
export function article(value: number | string): "a" | "az" {
  const text = String(value)
    .trim()
    .replace(/^[„“"'«([]+/u, "");
  const number = /^\d+(?:[\s  ]\d{3})*/u.exec(text)?.[0];
  if (number) return numberArticle(number.replace(/\D/g, ""));
  const word = /^\p{L}+/u.exec(text)?.[0];
  if (!word) return "a";
  const lower = word.toLocaleLowerCase("hu");
  const spelled = (word === word.toLocaleUpperCase("hu") && word.length <= 3) || ![...lower].some((c) => VOWELS.includes(c));
  const first = spelled ? VOWEL_NAMED.includes(word.charAt(0).toLocaleUpperCase("hu")) : VOWELS.includes(lower.charAt(0));
  return first ? "az" : "a";
}
